import './intro-text.scss';

export default () => {

};
